import React from 'react';
import './DateRangePicker.css';

/**
 * DateRangePicker - Selector de rango de fechas
 * 
 * @param {string} startDate - Fecha inicial (YYYY-MM-DD)
 * @param {string} endDate - Fecha final (YYYY-MM-DD)
 * @param {function} onChange - Callback con {startDate, endDate}
 * @param {function} onApply - Callback al aplicar filtro (opcional)
 * @param {boolean} showQuickSelect - Mostrar botones rápidos
 */
export default function DateRangePicker({ 
  startDate, 
  endDate, 
  onChange,
  onApply,
  showQuickSelect = true 
}) {
  
  const handleStartChange = (e) => {
    onChange({ startDate: e.target.value, endDate });
  };
  
  const handleEndChange = (e) => {
    onChange({ startDate, endDate: e.target.value });
  };
  
  const setQuickRange = (days) => {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - days);
    
    onChange({
      startDate: start.toISOString().split('T')[0],
      endDate: end.toISOString().split('T')[0]
    });
  };
  
  const clearDates = () => {
    onChange({ startDate: '', endDate: '' });
  };
  
  return (
    <div className="date-range-picker">
      <div className="date-range-picker__inputs">
        <div className="date-input-group">
          <label>From</label>
          <input 
            type="date"
            value={startDate || ''}
            onChange={handleStartChange}
            className="date-input"
          />
        </div>
        
        <span className="date-separator">→</span>
        
        <div className="date-input-group">
          <label>To</label>
          <input 
            type="date"
            value={endDate || ''}
            onChange={handleEndChange}
            className="date-input"
          />
        </div>
        
        {onApply && (
          <button 
            className="btn-apply"
            onClick={onApply}
          >
            Apply
          </button>
        )}
        
        <button 
          className="btn-clear"
          onClick={clearDates}
          title="Clear dates"
        >
          ✕
        </button>
      </div>
      
      {showQuickSelect && (
        <div className="date-range-picker__quick">
          <button onClick={() => setQuickRange(7)}>Last 7 days</button>
          <button onClick={() => setQuickRange(30)}>Last 30 days</button>
          <button onClick={() => setQuickRange(90)}>Last 90 days</button>
          <button onClick={() => setQuickRange(365)}>Last year</button>
        </div>
      )}
    </div>
  );
}
